module.exports = __webpack_public_path__ + "img/2.0b1b3a8a.png";